import { Directive, Input } from '@angular/core';

import { OptionValue9 } from '@ui/components/form9/common';

import { InputBase } from './input-base';

@Directive()
export abstract class ComplexInputBase<T> extends InputBase<T>
{
    @Input() getDisplayValue: (item: T) => OptionValue9;
    protected stateValue: T[] = [];
}
